import { connect } from 'react-redux';

import { CONTENTFUL_SEO_PAGES } from 'app/config';
import { getSeoPage } from 'app/marketplace/contentful/actions';
import { getFavoriteIds } from 'app/marketplace/favourites/selectors';
import {
  getMakePage,
  prepareVariables,
  getModelPage,
  getSeoPageFromState,
  getDataToFetch,
} from 'app/marketplace/contentful/spaces/seo/utils';
import { getVehicles } from 'app/marketplace/search/actions';
import { breakpointSelector } from 'app/shared/modules/globalEvents/selectors';
import {
  toggleFavourite,
  getFavouriteVehicleIds,
} from 'app/marketplace/favourites/actions';
import {
  budgetRangeSwitchFilterSelector,
  performanceRangeValueFilterSelector,
} from 'app/marketplace/filter/selectors';
import { VARIANT_PAGE } from 'app/marketplace/contentful/spaces/seo/constants';
import { updateFilters } from 'app/marketplace/contentful/spaces/seo/pages/Variant/utils';

import { Variant } from './Variant';

const type = VARIANT_PAGE;

Variant.loadAction = (_, props) => {
  return (dispatch) => {
    const {
      makePath,
      modelPath,
      variantPath,
      isStaging,
      isPreviewContentful,
    } = prepareVariables(props);

    dispatch(getFavouriteVehicleIds());

    return Promise.all(
      getDataToFetch({
        dispatch,
        type,
        makePath,
        modelPath,
        variantPath,
        isPreviewContentful,
        isStaging,
      }),
    );
  };
};

const mapStateToProps = (state, ownProps) => {
  const { variantPath, makePath, modelPath } = prepareVariables(ownProps);

  // Get page
  const { entry } = getSeoPageFromState({
    state,
    paths: { makePath, modelPath, variantPath },
  });

  // Get make with models as children
  const { entry: parentMake } = getSeoPageFromState({
    state,
    paths: { makePath },
  });

  const make = parentMake?.fields;

  // Get model with variants as children
  const { entry: parentModel } = getSeoPageFromState({
    state,
    paths: { makePath, modelPath },
  });

  const model = parentModel?.fields;

  const {
    search: { vehicles, vehicleCount, priceRange },
  } = state;

  return {
    make,
    model,
    variant: entry?.fields,
    entry,
    locale: 'de',
    list: vehicles,
    isLoading: !!state.search.pending,
    favouriteIds: getFavoriteIds(state),
    breakpoint: breakpointSelector(state),
    vehicleCount,
    priceRange,
    budgetRangeValue: budgetRangeSwitchFilterSelector(state),
    performanceUnit: performanceRangeValueFilterSelector(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    variantPath,
    makePath,
    modelPath,
    isStaging,
    isPreviewContentful,
  } = prepareVariables(ownProps);

  return {
    toggleFavourite(vehicle) {
      dispatch(toggleFavourite(vehicle));
    },
    getPage() {
      return dispatch(
        getSeoPage(
          variantPath,
          CONTENTFUL_SEO_PAGES,
          null, //  For client requests, no base is required
          type,
          isPreviewContentful,
          isStaging,
          2,
          {
            'fields.modelPath': modelPath,
            'fields.makePath': makePath,
          },
        ),
      );
    },
    getModelPage() {
      return getModelPage({
        base: null, //  For client requests, no base is required
        dispatch,
        modelPath,
        isPreviewContentful,
        isStaging,
      });
    },
    getMakePage() {
      return getMakePage({
        base: null, //  For client requests, no base is required
        dispatch,
        makePath,
        isPreviewContentful,
        isStaging,
      });
    },
    getVehicles() {
      return dispatch(getVehicles());
    },
    updateFilters(make, model, variant) {
      return dispatch(updateFilters(make, model, variant));
    },
  };
};

export const ConnectedVariant = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Variant);
